import { FinanceDataDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/finance-data-display-model";
import { AnfrageService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
  })
  export class GetAnfrageFinanceDataResolver implements Resolve<FinanceDataDisplayModel | undefined> {
    constructor(protected anfrageService: AnfrageService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService){}
  
    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<FinanceDataDisplayModel | undefined> {
      let id: string = <string>route.params['id'];

      await this.unfinishedHttpMethodsService.waitByUrl(state.url);

      if(this.portalContextService.CurrentAnfrage && this.portalContextService.CurrentAnfrage.id == id && this.portalContextService.CurrentAnfrage.financeData)
        return of(this.portalContextService.CurrentAnfrage.financeData).toPromise();
        
      return this.anfrageService.apiAnfrageAnfrageIdFinanceDataGet({ anfrageId: id }).pipe(map(response => {
        if (response) {
          if(this.portalContextService.CurrentAnfrage?.id == id && !this.portalContextService.CurrentAnfrage?.financeData)
          this.portalContextService.CurrentAnfrage.financeData = response;

          if(this.portalContextService.CurrentAnfrage?.financeData)
            return this.portalContextService.CurrentAnfrage.financeData;
        }

        return undefined;
      })).toPromise();;
    }
  }